import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class AddressPageAnalytics extends BaseAnalytics {
    constructor(category: string) {
        super();
        this.category = category;
    }

    changeAddressClicked(): void {
        this.send('click_to_change');
    }

    only100Clicked(): void {
        this.send('click_only_100');
    }

    lessThan1000Clicked(): void {
        this.send('click_less_then_1000');
    }

    continueClicked(): void {
        this.send('step_check_address', 'confirm');
    }

    checkClicked() {
        this.send('click address verification');
    }

    verificationSuccess() {
        this.send('address verification', 'success');
    }

    verificationFailed(reason?: string) {
        const message = reason
            ? `error_${reason}`
            : 'error';

        this.send('address verification', message);
    }

    popupAddressAgreement(label: string) {
        this.send('popup_address_dogovor', label);
    }
}

export default AddressPageAnalytics;
